import { useAuth0 } from "@auth0/auth0-react";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { OrgRolesAndAccountProvider } from "util/OrgRolesAccountContext";
import { OpenAPI } from "./client/openapi";
import { useEffect, useState } from "react";
import Notifications from "util/notifications";
import AppRoutes from "AppRoutes";

function App() {
  const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      if (isLoading) return;

      // Anonymous visitors only need the landing page
      if (!isAuthenticated) {
        setReady(true);
        return;
      }

      try {
        // Always fetch a fresh access token on reload to ensure we have a valid token,
        // rather than potentially using an expired cached one
        const freshToken = await getAccessTokenSilently({ cacheMode: "off" });
        OpenAPI.TOKEN = freshToken;
        setReady(true);
      } catch (err) {
        console.error("Unable to obtain access token:", err);
        Notifications.error(
          "Please reload, or log out and back in again to continue."
        );
      }
    };

    void init();
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  OpenAPI.BASE = process.env.REACT_APP_BACKEND_API_DOMAIN || "";

  if (!ready) return null;

  return (
    <div className="wrapper">
      <OrgRolesAndAccountProvider>
        <AppRoutes />
        <NotificationContainer />
      </OrgRolesAndAccountProvider>
    </div>
  );
}

export default App;
